// TODO: Direct import instead of common till shared bundle works in the page wise bundling for global context
import 'bootstrap-autocomplete';
import 'bootstrap-select';
import '../../../browse_view/src_ui/browse/bindings/index';

import { usePlacesAutocomplete } from 'commons/utils/geo';
import TrialFacets from './TrialFacets';
import TrialResultViewModel from './TrialResultViewModel';
import FindStudyViewModel from '../../../browse_view/src_ui/browse/FindStudyViewModel';
import browseLocation from '../../../browse_view/src_ui/browse/BrowseLocation';
import { showPopover } from "commons/bindings/popover";
import { createPopper } from '@popperjs/core';

function bindCustomPopovers(target = $('.popover-imagery')) {
  target.each(function () {
    const $target = $(this);
    const {
      target: popoverId,
      event = 'hover',
      strategy = 'fixed',
      hasClickAway = true,
      placement = 'auto',
    } = $target.data();
    const $popoverTarget = $(popoverId)[0];
    if (!$popoverTarget) return;
    const popoverRef = createPopper($target[0], $popoverTarget, {
      placement,
      strategy,
    });
    if (event === 'hover') {
      $target.mouseenter(function (e) {
        $('.popover-imagery').next('.shadow-tooltip').css('display','none');
        $('.popover-imagery').attr('aria-expanded', false);
        $('#whats-this').css('opacity',1);
        $('#infoimagery-information').css('display','none');
        showPopover.call(this, e, popoverRef, false);
      });
    }
  });
}

function bindWhatsPopover(target = $('.popover-imagery-wp')) {
  target.each(function () {
    const $target = $(this);
    const {
      target: popoverId,
      event = 'hover',
      strategy = 'fixed',
      hasClickAway = true,
      placement = 'auto',
    } = $target.data();
    const $popoverTarget = $(popoverId)[0];
    if (!$popoverTarget) return;
    const popoverRef = createPopper($target[0], $popoverTarget, {
      placement,
      strategy,
    });
    if (event === 'hover') {
      $target.mouseenter(function (e) {
        $('#whats-this').css('opacity',0);
        $('.popover-imagery').next('.shadow-tooltip').css('display','none');
        $('#whats-this').attr('aria-expanded', false);
        showPopover.call(this, e, popoverRef, false);
      }
      );
    }
  });
}

(function ($, document, window) {
  const defaultCondition = window.__MEDICAL_CONDITION__;
  const defaultLocation = {
    locationName: window.__LOCATION_PLACE__ || null,
    latitude: window.__LOCATION_LATITUDE__ || null,
    longitude: window.__LOCATION_LONGITUDE__ || null,
    country: window.__LOCATION_USER_COUNTRY__ || null,
  };
  const widgetId =  window.__WIDGET__ || null;
  const $trialSearchWrapper = document.getElementById('trial-search-wrapper');
  const $findStudy = document.getElementById('find-study-hero');

  try {
    $(function () {
      if($trialSearchWrapper){
        const $studyLocationInput = document.getElementById(
          'study-location-input'
        );
        const trialFacets = new TrialFacets();
        const trialResultViewModel = new TrialResultViewModel({
          defaultCondition,
          defaultLocation,
          widgetId,
        });
        usePlacesAutocomplete($studyLocationInput, {
          onPlaceChange: trialResultViewModel.trialSearch.handleLocationChange,
        }).catch(console.log);
        trialFacets.init();
        $trialSearchWrapper &&ko.applyBindings(trialResultViewModel, $trialSearchWrapper);
      }
      if($findStudy){
        const $studyLocationInput = document.getElementById(
          'search-study-location',
        );
        const findStudyViewModel = new FindStudyViewModel({ widgetId });
        usePlacesAutocomplete($studyLocationInput, {
          onPlaceChange: findStudyViewModel.handleLocationChange,
        }).catch(console.log);  
        $findStudy && ko.applyBindings(findStudyViewModel, $findStudy);
        browseLocation.init();
      }
      
    });
  } catch (err) {
    console.log(err.messages);
  }
bindCustomPopovers();
bindWhatsPopover();
$('.popover-imagery-cb').mouseenter(function(e){
      $('.popover-imagery').next('.shadow-tooltip').css('display','none');
      $('.popover-imagery').attr('aria-expanded', false);
      $('#whats-this').css('opacity',1);
      $('#infoimagery-information').css('display','none');
});
})($, document, window);
